<script lang="ts" setup>
import MascotIcon from '~/assets/icons/broadcast-mascot.svg';

const redirectTo = () => {
  window.open(
    'https://wazzup24.ru/help/how-to-configurate/' +
    'how-to-add-a-waba-template/',
    '_blank'
  );
};
</script>

<template>
  <div class="empty-templates">
    <div class="empty-templates__content">
      <MascotIcon />
      <div class="empty-templates__text">
        <h4>{{ $t('broadcast.emptyTemplate.title') }}</h4>
        <p>{{ $t('broadcast.emptyTemplate.description') }}</p>
      </div>
      <PButton
        :variant="'default'"
        :size="'small'"
        :color="'primary'"
        :loading="false"
        :nuxt="false"
        :type="'button'"
        :block="true"
        @click="redirectTo()"
        :style="{ width: '170px' }"
      >
        {{ $t('broadcast.emptyTemplate.button') }}
      </PButton>
    </div>
  </div>
</template>

<style scoped>
.empty-templates {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-templates__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 360px;
  gap: 24px;
}

.empty-templates__text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.empty-templates__content h4 {
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  line-height: 175%;
  letter-spacing: -0.18px;
  color: var(--common-black);
  white-space: pre-line;
}

.empty-templates__content p {
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  color: var(--common-asphalt);
}
</style>
